// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__4ivyL","title":"Header_title__XiMNZ","left":"Header_left__1YFPs","clinicName":"Header_clinicName__2pJU1"};